import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useCreatePersonalTreatmentPlanTemplateMutation } from "@/modules/admin/treatment/services/__generated__/useCreatePersonalTreatmentPlanTemplateMutation.graphql"

const mutation = graphql`
  mutation useCreatePersonalTreatmentPlanTemplateMutation($input: CreatePersonalTreatmentPlanTemplateInput!) {
    createPersonalTreatmentPlanTemplate(input: $input) {
      treatmentPlanTemplate {
        id
        name
        countries
        languages {
          language
          title
          followUpInstructions
          synonym
          recommendedTreatment
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
const useCreatePersonalTreatmentPlanTemplateMutationHook = () => {
  const [commit, isFlight] = useMutation<useCreatePersonalTreatmentPlanTemplateMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCreatePersonalTreatmentPlanTemplateMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useCreatePersonalTreatmentPlanTemplateMutationHook }
